// pollTranscodedVideo — wait for the transcodeFragmentVideo CF to produce
// fragments-videos/{id}.mp4 after a raw upload, then return its download URL.
// Exponential backoff (2s → 16s). Throws on timeout.
//
// Shared by FragmentNew (worker compose) and MapMark (collectible pin place).

import { getFirebase } from "@goodbye/firebase";
import { getDownloadURL, ref } from "firebase/storage";

export async function pollTranscodedVideo(
  id: string,
  maxAttempts = 8,
): Promise<string> {
  const storage = getFirebase().storage;
  const transcodedRef = ref(storage, `fragments-videos/${id}.mp4`);
  let delay = 2000;
  for (let i = 0; i < maxAttempts; i++) {
    try {
      return await getDownloadURL(transcodedRef);
    } catch {
      await new Promise((r) => setTimeout(r, delay));
      delay = Math.min(delay * 2, 16000);
    }
  }
  throw new Error("影片處理逾時、請稍後再試。");
}
